(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('userService', userService);

    userService.$inject = ['$http', 'CONFIG', 'messageService'];

    function userService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/users';
        var service = {
            getUsers: getUsers,
            getUser: getUser,
            saveUser: saveUser,
            updateUser: updateUser,
            deleteUser: deleteUser,
            thereEmail: thereEmail,
            getPermissions: getPermissions,
            savePermission: savePermission,
            getUserLogin: getUserLogin,
            getSession: getSession,
            getUserCredential: getUserCredential,
            saveUserCredential: saveUserCredential,
            updateUserCredential: updateUserCredential,
            deleteUserCredential: deleteUserCredential,
            getUsersByRegion: getUsersByRegion,
            getUsersByBranchOffice: getUsersByBranchOffice,
            updateAssociatedBranchOffice: updateAssociatedBranchOffice,
            getPositionTypes: getPositionTypes,
            isGeneralOrRegional: isGeneralOrRegional
        }

        return service;

        function getUsers(page, size, detailed){
            return $http.get(urlBase + '?page=' + page + '&size=' + size + '&detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getUser(userId, detailed){
            var params = (detailed != undefined) ? "?detailed=" + detailed : "";
            return $http.get(urlBase + "/" + userId + params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('users')
                });
        }

        function saveUser(user){
            return $http.post(urlBase, user)
                .then(function(response){
                    messageService.register('users');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('users');
                });
        }

        function updateUser(user, userId){
            return $http.put(urlBase + "/" + userId, user)
                .then(function(response){
                    messageService.registerUpdate('users');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('users')
                });
        }

        function deleteUser(userId){
            return $http.delete(urlBase + "/" + userId)
                .then(function(response){
                    messageService.registerDelete('users');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('users');
                });
        }

        function thereEmail(email){
            return $http.get(urlBase + "/thereEmail/" + email, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function getPermissions(){
            return $http.get(urlBase + "/permissions")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function savePermission(id){
            return $http.post(urlBase+"/createPermission/"+id)
                .then(function(response){
                    messageService.register('');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getUserLogin(){
            return $http.get(urlBase + "/userLogin")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSession(detailed){
            return $http.get(urlBase + "/session?detailed="+detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getUserCredential(clientId){
            return $http.get(urlBase + "/userCredential/" + clientId )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('clients')
                });
        }

        function saveUserCredential(user){
            return $http.post(urlBase+'/userCredential', user)
                .then(function(response){
                    return true;
                })
                .catch(function(error){
                    messageService.findAllError('clients')
                    return false
                });
        }

        function updateUserCredential(user){
            return $http.put(urlBase+'/userCredential', user)
                .then(function(response){
                    return true;
                })
                .catch(function(error){
                    messageService.findAllError('clients')
                    return false
                });
        }

        function deleteUserCredential(clientId,login){
            return $http.delete(urlBase + "/userCredential/" + clientId+"?login="+login)
                .then(function(response){
                    //messageService.registerDelete('clients');
                    return response;
                })
                .catch(function(){
                    //messageService.registerDeleteError('clients');
                });
        }

        function getUsersByRegion(regionId){
            return $http.get(urlBase + '/list/users-by/' + regionId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getUsersByBranchOffice(branchOfficeId){
            return $http.get(urlBase + '/list/users-by-branch-office/' + branchOfficeId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function updateAssociatedBranchOffice(userId,user){
            return $http.put(urlBase + "/update/associatedBranchOffice/" + userId, user)
                .then(function(response){
                    messageService.registerUpdate('users');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('users')
                });
        }

        function getPositionTypes(){
            return $http.get(urlBase + '/positionTypes')
                .then(function(response){
                    return response.data;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function isGeneralOrRegional(positionType) {
            var res = false;
            if(positionType === "GENERAL_ADMIN" || positionType === "REGIONAL_ADMIN") {
                res = true
            }
            return res;
        }
    }
})();
